const state = {
  is_login: false,
  user: null,
  login_page: false
}

const mutations = {
  login(state) {
    state.is_login = true
  },
  logout(state) {
    state.is_login = false
  },
  user(state, user) {
    state.user = user
  }
}

const getters = {
  user(state) {
    return state.user
  },
  isLogin(state) {
    return state.is_login
  },
  isBranch(state) {
    if (state.user) {
      return state.user.type === 'BRANCH'
    }
    return false
  },
  isStore(state) {
    if (state.user) {
      return state.user.type === 'STORE'
    }
    return false
  }
}

const actions = {
  logout({commit}) {
    axios
      .post('/api/store/logout')
      .then((res) => {
        window.location.href = '/'
      })
      .catch((error) => {
        console.log(error)
        // commit('alert/setAlert', { 'message': 'ログアウトに失敗しました。' }, { root: true });
      })
    setTimeout(() => {
      window.location.href = '/'
    }, 2000)
  },
  checkLogin({commit}) {
    if (window.user) {
      commit('user', window.user)
      commit('login', true)
    }
  },
  checkLoginApi({commit}) {
    axios.get('/api/store/check-login').then((res) => {
      if (!res.data.login) {
        window.location.href = '/'
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
